import { render, staticRenderFns } from "./pay_config.vue?vue&type=template&id=4378e5d0&scoped=true&"
import script from "./pay_config.vue?vue&type=script&lang=js&"
export * from "./pay_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4378e5d0",
  null
  
)

export default component.exports